import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { Table, TableColumnsType } from "antd";
import useAxios from "../../../hooks/useAxios";
import { IClassArticle, IGetClassArticles } from "../../../models/articles.model";
import useLoader from "../../../hooks/useLoader";
import { getClassArticles } from "../../../api/articles.api";
import { useTranslation } from "react-i18next";

const ClassArticlePane: FC = () => {
  const { t } = useTranslation();
  const { chosenClass } = useSelector((state: RootState) => state.class);

  const { data: res, isLoading, error, execute } = useAxios<IGetClassArticles>();
  useLoader(isLoading, [error]);

  useEffect(() => {
    if (chosenClass?.classCode) {
      execute(getClassArticles(chosenClass.classCode));
    }
  }, [chosenClass]);

  const columns: TableColumnsType<IClassArticle> = [
    {
      title: 'No.',
      dataIndex: 'rowNo',
      align: 'center',
      sorter: (a, b) => a.rowNo - b.rowNo,
    },
    {
      title: t('class.class.1'),
      dataIndex: 'memberName',
      align: 'center',
      sorter: (a, b) => a.memberName?.localeCompare(b.memberName),
      render: (value, record) => `${value}(${record.webId})`,
    },
    {
      title: t('class.class.2'),
      dataIndex: 'memberEngName',
      align: 'center',
      sorter: (a, b) => a.memberEngName?.localeCompare(b.memberEngName),
    },
    {
      title: t('class.class.3'),
      dataIndex: 'postCount',
      align: 'center',
      sorter: (a, b) => a.postCount - b.postCount,
    },
  ];

  return (
    <>
      <div className="comm-bx__between"> 
        <h3 className="sub-title">{chosenClass?.className}</h3>
      </div>
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={res?.data}
        pagination={{
          pageSize: 9999999,
        }}
        summary={() => {
          const total = res?.data?.reduce((acc, cur) => acc + cur.postCount, 0);
          return (
            <Table.Summary.Row
              style={{ backgroundColor: 'ghostwhite' }}
            >
              <Table.Summary.Cell
                index={0}
                colSpan={3}
                align="center"
              >
                {t('class.class.4')}
              </Table.Summary.Cell>
              <Table.Summary.Cell
                index={1}
                colSpan={1}
                align="center"
              >
                {total}
              </Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
    </>
  );
};

export default ClassArticlePane;